import { push } from 'react-router-redux';
import { delay } from 'redux-saga';
import { ROUTES, routeToPath } from '../../commons/routes/routes';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import itemMenuService from '../../commons/services/itensMenu';
import { actions, types } from '../modules/itemMenu';
import { flow } from '../modules/flow';

export default function* itemMenusSaga() {
	yield takeEvery(types.ITEMMENU_CONSULTAR_POR_ID, consultarPorCodigo);
	yield takeEvery(types.ITEMMENU_CONSULTAR_POR_FILTRO, consultarPorFiltro);
	yield takeEvery(types.ITEMMENU_CONSULTAR_PUBLICADOS, consultarItensMenuPublicados);
	yield takeEvery(types.ITEMMENU_LIMPAR, limpar);
	yield takeEvery(types.ITEMMENU_REMOVER, remover);
	yield takeEvery(types.ITEMMENU_SALVAR, salvar);
	yield takeEvery(types.ITEMMENU_PROXIMA_ORDEM, consultarProximaOrdem);
	yield takeEvery(types.ITEMMENU_CONSULTAR_DINAMICO, consultarMenuDinamico);

}

function* consultarPorCodigo(action) {
	yield* flow({
		type: action.type,

		fnTry: function* () {
			const itemMenu = yield call(itemMenuService.consultarPorCodigo, action.payload);

			yield put(actions.atualizarStore({ itemMenu }));
		}
	});
}

function* consultarMenuDinamico(action) {
	yield* flow({
		type: action.type,

		fnTry: function* () {
			const itemMenuDinamico = yield call(itemMenuService.consultarPorCodigo, action.payload);
			yield put(actions.atualizarStore({ itemMenuDinamico }));
		}
	});
}

function* consultarItensMenuPublicados(action) {
	yield* flow({
		type: action.type,

		fnTry: function* () {
			const menus = yield call(itemMenuService.consultarItensMenuPublicados);
			yield put(actions.atualizarStore({ menus }));
		}
	});
}

function* consultarProximaOrdem(action) {
	yield* flow({
		type: action.type,

		fnTry: function* () {
			const nu_ordem = yield call(itemMenuService.consultarProximaOrdem, action.payload);
			const itemMenu = { nu_ordem };
			yield put(actions.atualizarStore({ itemMenu }));
		}
	});
}

function* consultarPorFiltro(action) {
	yield* flow({
		type: action.type,

		fnTry: function* () {
			const [lista] = yield all([
				call(itemMenuService.consultarPorFiltro, action.payload || {}),
				call(delay, 750) // adicionado um delay de 750ms para exibir feedback para o usuário
			]);

			yield put(actions.atualizarStore({ lista }));
		}
	});
}

function* limpar(action) {
	yield* flow({
		type: action.type,

		fnTry: function* () {
			yield put(actions.atualizarStore({ itemMenu: null, lista: [] }));
		}
	});
}

function* salvar(action) {
	yield* flow({
		type: action.type,

		fnTry: function* () {
			const [itemMenu] = yield all([
				call(itemMenuService.salvar, action.payload),
				call(delay, 750) // adicionado um delay de 750ms para exibir feedback para o usuário
			]);
			yield put(actions.atualizarStore({ itemMenu }));
			yield put(push(routeToPath(ROUTES.EDITAR_ITEMMENU, { codigo: itemMenu.cd_item_menu })));

			yield put(actions.consultarItensMenuPublicados());
		}
	});
}

function* remover(action) {
	yield* flow({
		type: action.type,

		fnTry: function* () {
			yield call(itemMenuService.remover, action.payload.codigo);

			const [lista] = yield all([
				call(itemMenuService.consultarPorFiltro, action.payload.search),
				call(delay, 750) // adicionado um delay de 750ms para exibir feedback para o usuário
			]);

			yield put(actions.atualizarStore({ lista }));
			yield put(actions.consultarItensMenuPublicados());
		}
	});
}
